import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {PdfPrintSettings, SettingsModalComponent} from './settings-modal.component';

@Injectable({
    providedIn: 'root'
})
export class SettingsModalService extends ModalService {
    testModal() {
        this.createModalComponent(SettingsModalComponent);
        this.showModalComponent();
    }

    showModal(settings: PdfPrintSettings) {
        this.createModalComponent(SettingsModalComponent);
        const settingsModalComponentInstance = this.modalComponentRef.instance as SettingsModalComponent;
        settingsModalComponentInstance.settings = settings;
        this.showModalComponent();
        return settingsModalComponentInstance.modalClosed;
    }
}
